module.exports = __webpack_public_path__ + "img/pc.f62c1eb3.png";